export const variables = {
	1: {
		nom: 'Temperatura del termòmetre sec',
		unitat: 'ºC'
	},
	4: {
		nom: 'Temperatura màxima',
		unitat: 'ºC'
	},
	6: {
		nom: 'Temperatura mínima',
		unitat: 'ºC'
	},
	3: {
		nom: 'Humitat relativa',
		unitat: '%'
	},
	34: {
		nom: 'Precipitació total darreres 24h (dia pluviomètric)',
		unitat: 'mm'
	},
	45: {
		nom: 'Cobertura total de núvols',
		unitat: 'octes'
	},
	51: {
		nom: 'Estat de la mar',
		unitat: 'Escala de Douglas'
	},
	41: {
		nom: 'Gruix de neu a terra',
		unitat: 'cm'
	},
	49: {
		nom: 'Visibilitat'
	},
	82: {
		nom: 'Gruix de neu màxim en 24h',
		unitat: 'cm'
	},
	83: {
		nom: 'Velocitat del vent'
	},
	18: {
		nom: 'Direcció del vent'
	}
};



// WEBPACK FOOTER //
// ./src/components/commons/variables.js